:host {
  display: block;
}

.anchor-c-label {
  &--with-input,
  &--with-input-top {
    label {
      text-align: left;
      font-weight: var(--s-font-weight-paragraph-default);
      display: flex;
      flex-direction: column;
      gap: var(--p-size-static-100);
    }
  }
  &--with-input-left {
    label {
      display: flex;
      flex-direction: row;
    }
  }
}
